<dynamic-form
  [apiName]="apiName"
  [group]="formGroup"
  [areaName]="areaName"
  [label]="label"
  [model]="model"
  [hasDefault]="false"
  [isShowModal]="false"
  [columns]="columns"
  [erroremessage]="erroremessage"
  (valueChange)="onChanged($event)"
  (onRowSelected)="onRowSelected($event)"
  (cancelChange)="cancel()"
  (submitChange)="save()">
  <div class="fctContent">
    <st-lookup
      *ngIf="_detailLedgerLevel >= 1 && currentSubLedger?.HasDetailLedger1 === true"
      name="DetailLedgerId"
      [group]="formGroup"
      userClass="select-xmd"
      label="حساب تفصیلی 1"
      textFieldName="Title"
      apiName="DetailLedger/DetailLedgerWithSubLedgerId"
      valueFieldName="Id"
      [defaultHeight]="30"
      [isPaging]="true"
      [shouldBeChangedData]="shouldBeChangedData"
      [onDataStateChange]="onDataStateChange"
      textColumnsName="{{ ColumnsName }}"
      [disabled]="model?.AccVoucherHeaderId != undefined">
    </st-lookup>
    <st-lookup
      *ngIf="_detailLedgerLevel >= 2 && currentSubLedger?.HasDetailLedger2 === true"
      name="DetailLedger2Id"
      [group]="formGroup"
      userClass="select-xmd"
      apiName="DetailLedger/DetailLedgerWithSubLedgerId"
      textFieldName="Title"
      label="حساب تفصیلی 2"
      valueFieldName="Id"
      [defaultHeight]="30"
      [isPaging]="true"
      [shouldBeChangedData]="shouldBeChangedData"
      [onDataStateChange]="onDataStateChange"
      textColumnsName="{{ ColumnsName }}"
      [disabled]="model?.AccVoucherHeaderId != undefined">
    </st-lookup>
    <st-lookup
      style="margin-top: 0.6rem"
      *ngIf="_detailLedgerLevel >= 3 && currentSubLedger?.HasDetailLedger3 === true"
      name="DetailLedger3Id"
      [group]="formGroup"
      label="حساب تفصیلی 3"
      apiName="DetailLedger/DetailLedgerWithSubLedgerId"
      textFieldName="Title"
      valueFieldName="Id"
      [defaultHeight]="30"
      [isPaging]="true"
      [shouldBeChangedData]="shouldBeChangedData"
      [onDataStateChange]="onDataStateChange"
      textColumnsName="{{ ColumnsName }}"
      [disabled]="model?.AccVoucherHeaderId != undefined">
    </st-lookup>
    <st-lookup
      *ngIf="_detailLedgerLevel >= 4 && currentSubLedger?.HasDetailLedger4 === true"
      name="DetailLedger4Id"
      [group]="formGroup"
      label="حساب تفصیلی 4"
      apiName="DetailLedger/DetailLedgerWithSubLedgerId"
      textFieldName="Title"
      valueFieldName="Id"
      [defaultHeight]="30"
      [isPaging]="true"
      [shouldBeChangedData]="shouldBeChangedData"
      [onDataStateChange]="onDataStateChange"
      textColumnsName="{{ ColumnsName }}"
      [disabled]="model?.AccVoucherHeaderId != undefined">
    </st-lookup>
    <st-lookup
      *ngIf="_detailLedgerLevel >= 5 && currentSubLedger?.HasDetailLedger5 === true"
      name="DetailLedger5Id"
      [group]="formGroup"
      label="حساب تفصیلی 5"
      apiName="DetailLedger/DetailLedgerWithSubLedgerId"
      textFieldName="Title"
      valueFieldName="Id"
      [defaultHeight]="30"
      [isPaging]="true"
      [shouldBeChangedData]="shouldBeChangedData"
      [onDataStateChange]="onDataStateChange"
      textColumnsName="{{ ColumnsName }}"
      [disabled]="model?.AccVoucherHeaderId != undefined">
    </st-lookup>
    <st-lookup
      *ngIf="_detailLedgerLevel >= 6 && currentSubLedger?.HasDetailLedger6 === true"
      name="DetailLedger6Id"
      [group]="formGroup"
      label="حساب تفصیلی 6"
      apiName="DetailLedger/DetailLedgerWithSubLedgerId"
      textFieldName="Title"
      valueFieldName="Id"
      [defaultHeight]="30"
      [isPaging]="true"
      [shouldBeChangedData]="shouldBeChangedData"
      [onDataStateChange]="onDataStateChange"
      textColumnsName="{{ ColumnsName }}"
      [disabled]="model?.AccVoucherHeaderId != undefined">
    </st-lookup>
    <st-lookup
      *ngIf="_detailLedgerLevel >= 7 && currentSubLedger?.HasDetailLedger7 === true"
      name="DetailLedger7Id"
      [group]="formGroup"
      label="حساب تفصیلی 7"
      textFieldName="Title"
      valueFieldName="Id"
      apiName="DetailLedger/DetailLedgerWithSubLedgerId"
      [defaultHeight]="30"
      [isPaging]="true"
      [shouldBeChangedData]="shouldBeChangedData"
      [onDataStateChange]="onDataStateChange"
      textColumnsName="{{ ColumnsName }}"
      [disabled]="model?.AccVoucherHeaderId != undefined">
    </st-lookup>
  </div>
  <ng-container class="content">
    <div
      *ngIf="
        (_UnSelectAccounts && _UnSelectAccounts.length > 0) ||
        (model.AccCloseProfitandLossAccountsDetails && model.AccCloseProfitandLossAccountsDetails.length > 0)
      "
      class="detail">
      <div class="unseleted">
        <h5>حسابهای قابل انتخاب</h5>
        <kgrid
          id="UnSeledted1"
          [apiName]="apiName"
          [areaName]="areaName"
          [label]="label"
          [noToolBar]="true"
          [groupable]="true"
          [name]="apiName"
          [columns]="AccCloseProfitandLossAccountsDetails"
          [isEdit]="false"
          [isAdd]="false"
          [isDelete]="false"
          (onRowSelected)="RowForSelect = $event"
          [disableOnDoubleClick]="true"
          (onDoubleClick)="onUnSeletedDoubleClick($event)"
          [paging]="false"
          [groups]="groups"
          [dataList]="_UnSelectAccounts"
          reportName="AccCloseProfitandLossAccounts"
          pathPreFix="ACC">
        </kgrid>
      </div>
      <div class="buttons">
        <div class="btn">
          <ssg-button
            icon="icon-chevron-left"
            buttontype="button"
            (click)="moveLeft()"
            label="انتخاب"
            size="small"
            class="btn-seleted"
            [disabled]="!RowForSelect"
            appearance="flat">
          </ssg-button>
        </div>
        <div class="btn">
          <ssg-button
            icon="icon-chevron-right"
            buttontype="button"
            (click)="moveright()"
            label="حذف"
            class="btn-unSeleted"
            size="small"
            [disabled]="!RowForDelete || model?.AccVoucherHeaderId != undefined"
            appearance="flat">
          </ssg-button>
        </div>
        <div class="btn">
          <ssg-button
            icon="subicon icon-angle-double-left"
            buttontype="button"
            (click)="moveLeftAll()"
            label="انتخاب"
            class="btn-seleted"
            size="smal"
            [disabled]="_UnSelectAccounts.length <= 0"
            appearance="flat">
          </ssg-button>
        </div>
        <div class="btn">
          <ssg-button
            icon="subicon icon-angle-double-right"
            buttontype="button"
            (click)="moveRightAll()"
            label="حذف"
            class="btn-unSeleted"
            size="smal"
            [disabled]="
              !model.AccCloseProfitandLossAccountsDetails ||
              model?.AccCloseProfitandLossAccountsDetails?.length <= 0 ||
              model?.AccVoucherHeaderId != undefined
            "
            appearance="flat">
          </ssg-button>
        </div>
      </div>
      <div class="seleted">
        <h5>حسابهای انتخاب شده</h5>
        <kgrid
          id="Seledted1"
          [apiName]="apiName"
          [areaName]="areaName"
          [label]="label"
          (onRowSelected)="RowForDelete = $event"
          [disableOnDoubleClick]="true"
          (onDoubleClick)="onSeletedDoubleClick($event)"
          [noToolBar]="true"
          [groupable]="true"
          [name]="apiName"
          [columns]="AccCloseProfitandLossAccountsDetails"
          [isEdit]="false"
          [isAdd]="false"
          [isDelete]="false"
          [paging]="false"
          [groups]="groups"
          [dataList]="AccCloseProfitandLossAccountsDetailsList"
          reportName="AccCloseProfitandLossAccounts"
          pathPreFix="ACC">
        </kgrid>
      </div>
    </div>
  </ng-container>
  <ng-container class="footer">
    <ssg-button
      icon="fa fa-filter"
      buttontype="button"
      (click)="newVoucher()"
      class="action-btn"
      label="صدور سند"
      size="medium"
      [disabled]="model?.AccVoucherHeaderId != undefined || erroremessage || isNewRow">
    </ssg-button>
    <ssg-button
      icon="fa fa-filter"
      buttontype="button"
      (click)="deletVoucher()"
      class="action-btn"
      label="حذف سند"
      size="medium"
      [disabled]="!model?.AccVoucherHeaderId">
    </ssg-button>
  </ng-container>
</dynamic-form>
